import { render } from "./ImportStaffModal.vue?vue&type=template&id=62754540&scoped=true&ts=true"
import script from "./ImportStaffModal.vue?vue&type=script&lang=tsx"
export * from "./ImportStaffModal.vue?vue&type=script&lang=tsx"

import "./ImportStaffModal.vue?vue&type=style&index=0&id=62754540&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62754540"]])

export default __exports__